export const cyclope = (config) => {
  // Mock
  if (isMockMode()) {
    const localStorageValue = window.localStorage.getItem("sg1_mock_name")
    if (localStorageValue) {
      try {
        config.mock = process.env.NODE_ENV === "development" ? require(`../../mocks/${localStorageValue}.json`) : ""
      } catch (error) {
        console.error(`Le fichier "../../mocks/${localStorageValue}.json" n'existe pas.`)
      }
    } else {
      console.error("Le nom du mock SSE n'est pas défini en localStorage (sg1_mock_name)")
    }
  }

  // API
  if (isCustomAPIMode()) {
    const customApiURL = localStorage.getItem("sg1_custom_api_url")
    if (customApiURL !== "") {
      config.mock = ""
      // Remplacer le domaine de config.apiUrl par celui de customApiURL
      try {
        const originalUrl = new URL(config.apiUrl)
        const customUrl = new URL(customApiURL)
        originalUrl.protocol = customUrl.protocol
        originalUrl.host = customUrl.host
        originalUrl.port = customUrl.port
        config.apiUrl = originalUrl.toString()
      } catch (error) {
        console.error("Erreur lors du remplacement du domaine:", error)
        config.apiUrl = customApiURL
      }
      //  config.sseURL.exceptions && config.sseURL.exceptions[0] ? (config.sseURL.exceptions[0].domain = apiURL) : null
    } else {
      config.apiUrl = ""
      console.error("L'URL de l'API personnalisée n'est pas définie en localStorage (sg1_custom_api_url)")
    }
  }

  return config
}

const isMockMode = () => {
  return localStorage.getItem("sg1_mock_mode") === "true"
}

const isCustomAPIMode = () => {
  return localStorage.getItem("sg1_custom_api_mode") === "true"
}
